<template>
  <div>
    <span id="landing_title_app_name" :class="$tt('headline1')">Presents</span>
    <p :class="$tt('button')">SELECTED LOCATIONS FROM SKYLINE WITH A WEB 3D VIEWER</p>
    <ui-linear-progress indeterminate v-if="waterfallItems.length === 0"/>
    <ui-image-list
      :class="'presents-grid'"
      v-if="waterfallItems.length !== 0" masonry>

      <ui-image-item :class="'presents-grid-item'" v-for="(item, index) in waterfallItems" :key="index"
                     :withTextProtection="false">
        <ui-card>
          <ui-card-content v-ripple>
            <ui-card-media v-bind:style="{ backgroundImage: 'url(https://raw.githubusercontent.com/SkylineLWP/Presents/v2.0.0.0/img/' + item.imageName + ')' }" square>
            </ui-card-media>
            <div style="margin: 0.5rem 0.6rem;">
              <span :class="$tt('headline6')">{{ item.name}}</span>
              <br>
              <span :class="$tt('overline')">{{ "by " + item.author}}</span>
            </div>
          </ui-card-content>
          <ui-list-divider/>
          <ui-card-actions v-ripple fullBleed>
            <ui-button v-on:click="openQRDialog(item)">
              Scan QR Code
              <template #after>
                <ui-icon>pageview</ui-icon>
              </template>
            </ui-button>
          </ui-card-actions>
          <ui-card-actions v-ripple fullBleed>
            <ui-button>
              View in Web 3D
              <template #after>
                <ui-icon>3d_rotation</ui-icon>
              </template>
            </ui-button>
          </ui-card-actions>
        </ui-card>
      </ui-image-item>
    </ui-image-list>

    <ui-dialog id="qr_scan_dialog" v-bind:closable="true" v-bind:maskClosable="true" v-model="qrCodeDialogOpen">
      <ui-dialog-title>QR Code For This Location</ui-dialog-title>
      <ui-dialog-content style="display: block;padding: 0;margin: 0;">
        <transition name="fade">
          <div v-if="selectedQRItem != null">
            <vue-qr style="margin: 2rem;" v-bind:size="320" v-bind:margin="0" v-bind:logoCornerRadius="16" v-bind:dotScale="0.2" v-bind:logoSrc="'/img/app_icon@256.png'" v-bind:text="selectedQRItem != null ? JSON.stringify(selectedQRItem) : ''" >
            </vue-qr>
          </div>
        </transition>
      </ui-dialog-content>
      <ui-dialog-actions>
        <ui-button class="big-round-corner-button" v-on:click="closeQRDialog" outlined>Done</ui-button>
      </ui-dialog-actions>
    </ui-dialog>
  </div>
</template>

<script>
import jQuery from 'jquery'
import VueQr from 'vue-qr'
import UiButton from 'balm-ui/src/scripts/components/button/button'

export default {
  name: 'presents',
  created: function () {

  },
  mounted: function () {
    const _this = this
    jQuery.getJSON('https://raw.githubusercontent.com/SkylineLWP/Presents/v2.0.0.0/dataset.json', function (json) {
      _this.waterfallItems = json
    })
  },
  methods: {
    closeQRDialog: function () {
      this.qrCodeDialogOpen = false
    },
    openQRDialog: function (item) {
      this.selectedQRItem = item
      console.log(JSON.stringify(item))
      this.qrCodeDialogOpen = true
    }
  },
  data () {
    return {
      waterfallItems: [],
      qrCodeDialogOpen: false,
      selectedQRItem: null
    }
  },
  components: {
    UiButton,
    VueQr
  }
}
</script>

<style scoped>

</style>
